angular.module('picmonicng').factory('SpacedRep', [
  '$state',
  'UserService',
  'TokenService',
  '$modal',
  'PicmonicQueue',
  function ($state, UserService, TokenService, $modal, PicmonicQueue) {
    return {
      start: function (facts) {
        if (!UserService.user.is_trial || TokenService.values.spacedrep_rounds > 0) {
          PicmonicQueue.goToQuiz('today', 'spacedrep', facts);
        } else {
          $modal.open({
            templateUrl: '/templates/modals/spacedrep-limit.html',
            backdrop: 'static',
            keyboard: false,
            controller: [
              '$scope',
              '$modalInstance',
              'LearnService',
              'PlaylistService',
              'TokenService',
              'UserService',
              'MarketOptionsConfig',
              '$state',
              '$modal',
              '$timeout',
              function (
                $scope,
                $modalInstance,
                LearnService,
                PlaylistService,
                TokenService,
                UserService,
                MarketOptionsConfig,
                $state,
                $modal,
                $timeout
              ) {
                $scope.LearnService = LearnService;
                $scope.UserService = UserService;
                $scope.TokenService = TokenService;
              },
            ],
          });
        }
      },
    };
  },
]);
